/* eslint-disable import/no-cycle */
import { adminApi } from '@/includes/contentManagementApi';

function unwrap(response) {
  return response?.data?.data ?? response?.data ?? response;
}

async function readSseStream(response, handlers) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n\n');
    buffer = parts.pop() ?? '';

    for (const part of parts) {
      const lines = part.split('\n');
      let event = 'message';
      let data = '';
      for (const line of lines) {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        if (line.startsWith('data:')) data += line.slice(5).trim();
      }
      if (!data) continue;
      const parsed = JSON.parse(data);
      if (event === 'token' && handlers.onToken) handlers.onToken(parsed.token);
      if (event === 'done' && handlers.onDone) handlers.onDone(parsed);
      if (event === 'error' && handlers.onError) handlers.onError(parsed);
    }
  }
}

function authHeaders() {
  const token = localStorage.getItem('jwt') || localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) {
    headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return headers;
}

const coachingService = {
  async getStatus() {
    return unwrap(await adminApi.get('/coaching/status'));
  },

  async listDimensions() {
    return unwrap(await adminApi.get('/coaching/dimensions'));
  },

  async createSession({ sessionType, profilingMode, startDimensionValue, singleDimensionOnly } = {}) {
    const payload = {};
    if (sessionType) payload.sessionType = sessionType;
    if (profilingMode) payload.profilingMode = profilingMode;
    if (startDimensionValue) payload.startDimensionValue = startDimensionValue;
    if (singleDimensionOnly) payload.singleDimensionOnly = true;
    return unwrap(await adminApi.post('/coaching/sessions', payload));
  },

  async previewProfiling() {
    return unwrap(await adminApi.get('/coaching/profiling/preview'));
  },

  async createProfilingSession() {
    return this.createSession({ sessionType: 'profiling' });
  },

  async getSession(sessionId) {
    return unwrap(await adminApi.get(`/coaching/sessions/${sessionId}`));
  },

  async sendMessage(sessionId, content) {
    return unwrap(await adminApi.post(`/coaching/sessions/${sessionId}/messages`, { content }));
  },

  async sendMessageStream(sessionId, content, { onToken, onDone, onError }) {
    const response = await fetch(
      `/content-management-api/coaching/sessions/${sessionId}/messages?stream=true`,
      {
        method: 'POST',
        headers: authHeaders(),
        body: JSON.stringify({ content }),
      },
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err?.message || 'Coaching message failed');
    }

    await readSseStream(response, { onToken, onDone, onError });
  },

  async advanceDimension(sessionId) {
    return unwrap(await adminApi.post(`/coaching/sessions/${sessionId}/advance`));
  },

  async getProfile() {
    return unwrap(await adminApi.get('/coaching/profile'));
  },

  async seedSession(preset, sessionType = 'coaching') {
    return unwrap(await adminApi.post('/coaching/sessions/seed', { preset, sessionType }));
  },
};

export default coachingService;
